import React from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
} from "@mui/material";
import serviceImage1 from "../assets/images/sevicesimg1.jpg";
import serviceImage2 from "../assets/images/servicesimg2.jpg";
import serviceImage3 from "../assets/images/servicesimg3.jpg";
import serviceImage4 from "../assets/images/servicesimg4.jpg";

const WhyUs = () => {
  return (
    <div className="container mt-5">
      <Grid item xs={12} id="service1" data-aos="zoom-in">
        <Box sx={{ textAlign: "center", my: 4 }}>
          <Typography
            variant="h3"
            className="h3"
            sx={{ fontWeight: "bold", mb: 2 }}
          >
            Why Choose Home Medical Care?
          </Typography>
          <Typography variant="h6">
            Because every life deserves accessible, quality care—even at home.
          </Typography>
        </Box>
      </Grid>

      <Grid item xs={12} container spacing={4}>
        {[
          {
            image: serviceImage1,
            title: "Pregnancy Care",
            text: "Our pregnancy care service offers holistic and personalized monitoring from the first trimester until delivery. We focus on ensuring the health and well-being of both mother and baby through regular checkups, nutrition counseling, and access to experienced gynecologists—all from the comfort of your home.",
          },
          {
            image: serviceImage2,
            title: "Elderly Care",
            text: "We understand the challenges elderly individuals face when visiting hospitals. Our home support includes scheduled health checkups, doctor consultations, medication management, and emergency attention—allowing seniors to receive trusted care where they feel most secure.",
          },
          {
            image: serviceImage3,
            title: "Newborn & Child Care",
            text: "Our pediatric experts assist parents with vaccination schedules, general health monitoring, and nutrition plans. From infants to toddlers, we ensure your child receives essential care and develops strong immunity with regular follow-ups and expert advice—all done conveniently at home.",
          },
          {
            image: serviceImage4,
            title: "Home Physiotherapy",
            text: "Recover faster without the stress of hospital visits. Our physiotherapists provide rehabilitation sessions for patients healing from surgery, strokes, or chronic conditions. These sessions not only improve physical strength but also enhance mobility and emotional well-being.",
          },
        ].map((service, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 200}
          >
            <Box sx={{ height: "100%", display: "flex" }}>
              <Card sx={{ backgroundColor: "#e5f2ff" }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={service.image}
                  alt={service.title}
                />
                <CardContent sx={{ backgroundColor: "#e5f2ff" }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    {service.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ marginTop: 1 }}
                  >
                    {service.text}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default WhyUs;
